<template>
  <div class="day">
    <h1 class="day-title">{{$route.params.date}}</h1>
    <ul class="day-list">
      <li
        v-for="item in items"
        class="day-list-item"
        :class="{'open': item.open}"
      >
        <DayTitle class="time" :itemId="item.id"></DayTitle>
        <div class="action">
          <p v-if="!item.open" @click="toggleOpen(item)">
            {{item.action}}
            <span v-if="item.action.length == 0">내용을 작성해주세요</span>
            <!-- <button v-if="item.action.length == 0" @click="toggleOpen(item)">작성하기</button> -->
          </p>
          <input v-if="item.open" type="text" v-model="item.action" placeholder="한 일을 작성해주세요" @keyup.enter="updateItem(item)">
        </div>
        <DayScore class="score" :item="item" @onUpdateScore="onUpdateScore"></DayScore>
        <div class="note" v-if="item.open">
          <textarea v-model="item.note" placeholder="노트를 작성해 주세요"></textarea>
        </div>
        <div class="buttons" v-if="item.open">
          <button class="save" @click="updateItem(item)">저장</button>
          <button class="cancel" @click="toggleOpen(item)">취소</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

import DayTitle from './DayTitle';
import DayScore from './DayScore';

export default {
  name: 'Day',
  components: {
    DayTitle,
    DayScore
  },
  props: [

  ],
  data() {
    return {
      items: []
    };
  },
  methods: {
    getItems() {
      /*
      firebase의 db에서 오늘 날짜의 데이터를 가져옵니다
      */
      let endpoint = `https://dailyreport-c9ef9.firebaseio.com/items.json?orderBy="$key"&startAt="${this.$route.params.date}"`;
      axios.get(endpoint).then((res) => {
        /*
        가져온 데이터를 this.items에 바인딩합니다.
        firebase에서 가져온 데이터는 object형태입니다. 이것을 템플릿에서 v-for등을 이용해 쓸 수 있도록 array로 바꾸고 화면에 출력하고 편집할 수 있는 형태로 바꿉니다.
        */
        this.items = this.displayItems(res.data);
      });
    },
    displayItems(result) {
      /*
      object형태의 데이터를 array로 바꾸고 vue에서 보고, 편집할 수 있는 형태로 바꿉니다.
      */
      let startTime = '08:00';
      let items = [];

      /*
      하루를 2시간 간격으로 기록하기 때문에 12개의 원소를 가진 array를 만듭니다.
      */
      for (var i = 0; i < 12; i++) {
        /*
        주어진 날짜(오늘)을 기준으로 moment오브젝트를 만들어 줍니다.
        */
        let datetime = moment(this.$route.params.date + ' ' + startTime);
        /*
        itemId를 만들어 줍니다. 날짜-시작시간-끝나는시간의 형태입니다.
        */
        let itemId = `${this.$route.params.date}-${datetime.add(i*2, 'hours').format('HH')}-${datetime.add(2, 'hours').format('HH')}`;

        /*
        itemId가 포함된 아이템 구조를 만들어줍니다.
        */
        let item = {
          id: itemId,
          score:undefined,
          action:'',
          note:'',
          open:false
        }

        /*
        db에서 가져온 데이터가 있다면 검색하여 아이템정보를 넣어줍니다.
        */
        Object.keys(result).map((key) => {
          if(key == itemId) {
            item = result[key];
          }
        });

        /*
        빈 아이템 또는 이미 있는 아이템 데이터를 배열에 넣어서 리턴합니다.
        */
        items.push(item);
      }
      return items;
    },
    updateItem(item) {
      /*
      쓰기 모드를 닫습니다
      */
      item.open = false;
      /*
      엔드포인트를 만듭니다. 서버주소/itemId.json의 형태이고 주어진 item오브젝트의 id를 가지고 만듭니다.
      */
      let endpoint = `https://dailyreport-c9ef9.firebaseio.com/items/${item.id}.json`;
      /*
      엔드포인트에 수정된 item 오브젝트를 실어보냅니다.
      */
      axios.put(endpoint, item).then((res)=>{
        /*
        저장, 업데이트 후 다시 목록을 조회하여 화면을 최신으로 업데이트합니다.
        */
        this.getItems();
      });
    },
    onUpdateScore(item, score) {
      /*
      현재 item의 score 데이터를 주어진 파라미터로 바꿔주고,
      */
      item.score = score;
      /*
      item 업데이트 함수를 호출해서 업데이트를 진행합니다.
      */
      this.updateItem(item);
    },
    toggleOpen(item) {
      item.open = !item.open;
    }
  },
  computed: {

  },
  created() {
    this.getItems();
  },
  watch: {
    '$route' (to, from) {
      /*
        단순히 route만 바뀔 때는 created가 실행되지 않으므로 라우터 변경에 맞춰 아이템 받아오기를 실행
      */
      this.getItems();
    }
  }
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Day.vue